// import _get from "lodash";
const RequestParser = {};
RequestParser.getRequestVehicleParser = (res) => {
  if (!res) {
    return {};
  }
 

const data = res.result.data

  if (res) {
    res = data;
    return res;
  }


  
};  



export { RequestParser };